import { render, staticRenderFns } from "./orderBasicInfo.vue?vue&type=template&id=02454426&scoped=true&"
import script from "./orderBasicInfo.vue?vue&type=script&lang=js&"
export * from "./orderBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./orderBasicInfo.vue?vue&type=style&index=0&id=02454426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02454426",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02454426')) {
      api.createRecord('02454426', component.options)
    } else {
      api.reload('02454426', component.options)
    }
    module.hot.accept("./orderBasicInfo.vue?vue&type=template&id=02454426&scoped=true&", function () {
      api.rerender('02454426', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/module/orderBasicInfo.vue"
export default component.exports